import {
  GenericMarkdown,
  PageOverview,
  EasyWins,
  Profile,
  VideoLibrary,
  Consumption,
  FreeProducts,
  Checkout,
  Thankyou,
  PageLeaderboard,
  PageMeterRead,
} from './pages/lazy';
import { Routes } from './interfaces';

const routes: Routes = {
  '/portal': {
    template: <PageOverview />,
    authRequired: true,
  },
  '/use': {
    template: <Consumption />,
    authRequired: true,
  },
  '/easy-actions': {
    template: <EasyWins />,
    authRequired: true,
  },
  '/video-library': {
    template: <VideoLibrary />,
    authRequired: true,
  },
  '/free-products': {
    template: <FreeProducts />,
    authRequired: true,
  },
  '/free-products/checkout': {
    template: <Checkout />,
    authRequired: true,
  },
  '/free-products/thankyou': {
    template: <Thankyou />,
    authRequired: true,
  },
  '/profile': {
    template: <Profile />,
    authRequired: true,
  },
  '/faq': {
    template: <GenericMarkdown />,
  },
  '/contact-us': {
    template: <GenericMarkdown />,
  },
  '/terms-and-conditions': {
    template: <GenericMarkdown />,
  },
  '/privacy': {
    template: <GenericMarkdown />,
  },
  '/cookies': {
    template: <GenericMarkdown />,
  },
  '/other-policies': {
    template: <GenericMarkdown />,
  },
  '/end-user-license-agreement': {
    template: <GenericMarkdown />,
  },
  '/moderation-policy': {
    template: <GenericMarkdown />,
  },
  '/meter-read': {
    template: <PageMeterRead />,
    authRequired: true,
  },
  '/leaderboard': {
    template: <PageLeaderboard />,
    authRequired: true,
  },
};

export default routes;
